import React from 'react';

import {formatDate} from 'utils/datetime';

import ButtonDropdown from 'components/ButtonDropdown';
import StatusBox from 'components/StatusBox';
import ExternalLink from 'components/ExternalLink';

import './styles.css';

const BaseInformation = ({overpayment, openVoidOverpaymentModal}) => {
  return (
    <div className="BaseInformation">
      <div className="data">
        <div className="section">
          <div className="header">To</div>
          <div className="text">{overpayment.tenant.fullName}</div>
        </div>
        <div className="section">
          <div className="header">Date</div>
          <div className="text">{formatDate(overpayment.paymentDate)}</div>
        </div>

        <div className="section">
          <div className="header">Account</div>
          <div className="text">{overpayment.xeroAccount}</div>
        </div>

        <div className="section">
          <div className="header">Xero overpayment</div>
          <div className="text">
            {overpayment.xeroId ? (
              <ExternalLink
                className="xeroLink"
                href={overpayment.xeroLink}
                targetBlank>
                Overpayment →
              </ExternalLink>
            ) : (
              <StatusBox color={StatusBox.RED} status="Not synced" />
            )}
          </div>
        </div>
      </div>
      <div className="options">
        <ButtonDropdown title="Overpayment options" className="scheduleOptions">
          <ButtonDropdown.Option onClick={() => alert('Not implemented')}>
            Sync Overpayment
          </ButtonDropdown.Option>
          <ButtonDropdown.Option
            disabled={!overpayment.isVoidable}
            onClick={openVoidOverpaymentModal}>
            Void Overpayment
          </ButtonDropdown.Option>
          <ButtonDropdown.Option onClick={() => alert('Not implemented')}>
            Add Xero ID manually
          </ButtonDropdown.Option>
        </ButtonDropdown>
      </div>
    </div>
  );
};

export default BaseInformation;
